// @noflow
import './checkbox.component.css';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input``;

Checkbox.propTypes = {
    className: PropTypes.string
};

export default function Checkbox({ className, ...props }) {
    return (
        <StyledInput {...props} className={classnames('checkbox', 'general-icon__tick', className)} type="checkbox" />
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/checkbox/checkbox.component.js